<template>
  <div class="export-by-page-container">
    <button-submit size="medium"
                   button-txt="确认导入"
                   type="primary"
                   @click.native.prevent="handelClick"/>
    <div v-if="loading" class="mask">
      <div style="text-align: center;">
        <el-progress type="circle" :percentage="percentage" text-color="white" color="#ff3176"/>
        <h2 style="color: #FFFFFF;text-align: center;">导入中...</h2>
        <h2 style="color: #FFFFFF;text-align: center;">请勿关闭或刷新页面</h2>
        <h3 style="color: #FFFFFF;text-align: center;">
          导入数 {{ list.length|numberFormat }} 条，已用时 {{ (interval_ms / 1000)|numberFormat(2) }} s</h3>
      </div>
    </div>
  </div>
</template>
<script>

import {liveGuaranteeBatchCreate} from "../../../../api/liveGuarantee";
import {importRecordsCreate, importRecordsUpdate} from "../../../../api/importRecords";

export default {
  name: 'ImportSubmit',
  props: {
    list: {
      type: [Array]
    },
    fileName: {
      type: [String]
    }
  },
  data() {
    return {
      loading: false,
      interval: null,
      interval_ms: 0,
      percentage: 0,
      import_record_id: false
    }
  },
  methods: {
    /**
     * 开始导入
     * @returns {Promise<void>}
     */
    handelClick: async function () {
      const _this = this
      _this.interval = setInterval(function () {
        _this.interval_ms += 10
      }, 10)

      await this.eventStart()
      if (!this.import_record_id) {
        return;
      }

      this.loading = true
      await this.do()
      this.loading = false

      await this.eventEnd()
    },
    eventStart: async function () {
      this.percentage = 0
      this.import_record_id = false
      const data = {
        'table': 'live_guarantee_pool',
        'title': this.fileName,
        'rows_count': this.list.length,
      }
      const {success, model, message} = await importRecordsCreate(data)
      if (!success) {
        this.$message.error(message || '导入失败！')
        return;
      }
      this.import_record_id = model.id || false
    },
    eventEnd: async function () {
      const _this = this
      const response = await this.updateImportRecords()
      _this.$message.success('操作结束')
      _this.interval_ms = 0
      _this.interval && clearInterval(_this.interval)
      this.$emit('end', response)
    },
    updateImportRecords: async function () {
      return await importRecordsUpdate({
        id: this.import_record_id,
        table: 'live_guarantee_pool',
        use_time: this.interval_ms
      })
    },
    getPageData: function (start) {
      let table = []
      if (!Array.isArray(this.list)) {
        return table
      }
      const end = start + 100
      table = this.list.slice(start, end)
      return table
    },
    do: async function () {
      const total = this.list.length
      for (let i = 0; i < total; i += 100) {
        await liveGuaranteeBatchCreate({data: this.getPageData(i), import_record_id: this.import_record_id})
        await this.updateImportRecords()
        this.percentage = parseInt((i * 100 / total) + '')
      }
    }
  }
}

</script>
<style lang="scss">
.export-by-page-container {
  display: inline;

  .el-button [class*=el-icon-] + span {
    margin-left: 0;
  }

  .mask {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(0, 0, 0, .8); /*一般遮罩随便设置一个颜色*/
    z-index: 1001;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .el-progress__text {
    color: #FFFFFF !important;
  }
}
</style>
